export default __webpack_public_path__ + "static/media/Group1497-Yono2@2x.50055a4a.png";